import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-media-viewer',
    templateUrl: './media-viewer.component.html',
    styleUrls: ['./media-viewer.component.scss'],
    standalone: false
})
export class MediaViewerComponent implements OnInit {

  @Input() model;
  @Input() languages;
  @Input() defaultLang;

  constructor() {
  }

  ngOnInit() {
  }

}
